import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getCoachAiName } from 'utils/i18n';
import { openMindsetAgentWithMessage } from 'utils/mindset';
import { COACH_AI_ROUTE } from 'utils/routes';
import Box from 'components/Box';
import Button from 'components/Button';
import CoachAiAvatar from 'components/Avatar/CoachAIAvatar';
import { SearchWidgetCard } from './SearchWidgetCard';
import useSearchParameter from 'hooks/useSearchParameter';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function CoachAiLauncherWidget() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useSearchParameter = useSearchParameter('q'),
    _useSearchParameter2 = _slicedToArray(_useSearchParameter, 1),
    q = _useSearchParameter2[0];
  var navigate = useNavigate();
  var coachAiName = getCoachAiName();
  function askCoachAiAboutSearch() {
    navigate(COACH_AI_ROUTE);
    openMindsetAgentWithMessage(String(q !== null && q !== void 0 ? q : ''), {
      threadTitle: t('coach_ai_thread_title_search', {
        term: String(q !== null && q !== void 0 ? q : '')
      })
    });
  }
  return /*#__PURE__*/_jsxs(SearchWidgetCard, {
    icon: /*#__PURE__*/_jsx(CoachAiAvatar, {}),
    title: coachAiName,
    children: [/*#__PURE__*/_jsx(Box, {
      as: "p",
      style: {
        whiteSpace: 'pre-wrap'
      },
      my: "xs",
      children: t('coach_ai_ask_about', {
        coachAiName: coachAiName,
        searchInput: q
      })
    }), /*#__PURE__*/_jsx(Button, {
      fullWidth: true,
      iconRight: "arrow-right",
      variant: "primary",
      onClick: askCoachAiAboutSearch,
      children: t('coach_ai_ask', {
        coachAiName: coachAiName
      })
    })]
  });
}